import request from '../../../request/request';

const getMessages = ({ page, size, sort, status }) => {
  const params = { page: page - 1, size };
  if (sort) {
    params.sort = `${sort.column},${sort.sortBy}`;
  }
  if (status && status.length > 0) {
    params.status = status.join(',');
  }
  return request({
    url: '/api/broadcast/messages',
    params
  });
};

const createMessage = ({ message, startTime, endTime }) => {
  return request({
    url: '/api/broadcast/messages',
    method: 'POST',
    data: { message, startTime, endTime }
  });
};

const updateMessage = ({ id, message, startTime, endTime }) => {
  return request({
    url: `/api/broadcast/messages/${id}`,
    method: 'PUT',
    data: { message, startTime, endTime }
  });
};

const deleteMessage = ({ id }) => {
  return request({
    url: `/api/broadcast/messages/${id}`,
    method: 'DELETE'
  });
};

export { getMessages, createMessage, updateMessage, deleteMessage };
